class CollectionSeoFooter extends HTMLElement {
  #accordion = null
  #summary = null

  constructor() {
    super()

    this.toggleAccordionHandler = this.toggleAccordionHandler.bind(this)
  }

  connectedCallback() {
    this.#accordion = this.querySelector('.js-marketing-copy__accordion-item')
    this.#summary = this.querySelector('.js-accordion-item__summary')

    if (this.dataset.accordionFunctionality === 'true') {
      this.#summary.classList.remove("visibility-hidden")
      this.#setupEventListeners()
    } else {
      this.#accordion.toggleAttribute("open", true)
      this.#summary.classList.add("visibility-hidden")
    }
  }

  disconnectedCallaback() {
    if (this.dataset.accordionFunctionality === 'true') {
      this.#accordion.removeEventListener('toggle', this.toggleAccordionHandler)
    }
  }

  #setupEventListeners() {
    this.#accordion.addEventListener('toggle', this.toggleAccordionHandler)
  }

  toggleAccordionHandler(e) {
    this.#summary.textContent = this.#accordion.open ? this.dataset.readLessText : this.dataset.readMoreText
    this.#summary.setAttribute('aria-expanded', this.#accordion.open)
  }
}

customElements.define('collection-seo-footer', CollectionSeoFooter)
